import { Location } from "history";
import * as qs from "query-string";
import * as React from "react";
import { Redirect } from "react-router";
import { IAuthState } from "../../model";

export interface IProps {
    component?: React.ComponentClass;
    auth: IAuthState;
    location: Location;
    exact?: boolean;
    path?: string;
    render?: (component: any) => any;
    onAuth0Callback: () => void;
}

export default class CallbackRoute extends React.Component<IProps> {
    public componentWillMount() {
        const { onAuth0Callback } = this.props;
        /*
         If we are coming back from a hosted auth0 login page, begin authentication flow.
         --------------------------------------------------------------------------------
          - Get user info from auth0 using the access token in callback the uri (network call).
          - Remove the token from the url bar.
          - Set the access token and user info in state and localStorage.
        */
        if (window.location.hash.search("access_token") > -1) {
            onAuth0Callback();
        }
    }

    public render(): React.ReactNode {
        const { location, auth } = this.props;

        const keys = qs.parse(location.search);

        // returnTo was double encoded to pass through Auth0. So manually decode here
        const redirectUri: string = decodeURIComponent(keys.returnTo as string);
        const searchStartIndex = redirectUri.indexOf("?");
        const path = redirectUri.slice(0, searchStartIndex);
        const hashStartIndex = redirectUri.indexOf("#");
        const searchStr = redirectUri.slice(searchStartIndex, hashStartIndex === -1 ? redirectUri.length : hashStartIndex);
        const hashStr = hashStartIndex === -1 ? "" : redirectUri.slice(hashStartIndex);

        return (auth.isAuthenticating ? null
            : (
                <Redirect to={{
                    pathname: path,
                    search: searchStr as unknown as string,
                    hash: hashStr,
                }}
                />
            ));
    }
}
